module.exports = __webpack_public_path__ + "static/creator-tokens-stable-income-df8995109b94a6aac10227b4b282dc5d.webp";